import TransactionHistory from "components/ArtWork/TransactionHistory";
import NamingHistory from "components/ArtWork/NamingHistory";

import React, { useState } from "react";

const GangstaActivity = ({ TransactionHistoryData, NamingHistoryData }) => {
  return (
    <div className="GangstaActivity grey-border profile-page-section-radius">
      <p className="title" style={{ color: "var(--transaction-history)" }}>
        Activity
      </p>
      <TransactionHistory data={TransactionHistoryData} />
      <NamingHistory data={NamingHistoryData} />
    </div>
  );
};

export default GangstaActivity;
